import styled from 'styled-components';

const ConsultingServicesWrapper = styled.section`
  padding: 100px 0;
  background: #f8f9fa;

  @media (max-width: 767px) {
    padding: 60px 0;
  }

  .section-header {
    text-align: center;
    margin-bottom: 60px;
  }

  h2 {
    font-size: 42px;
    font-weight: 300;
    color: #1a1a2e;
    letter-spacing: -0.025em;
    line-height: 1.2;
    margin-bottom: 20px;

    @media (max-width: 991px) {
      font-size: 36px;
    }
    @media (max-width: 575px) {
      font-size: 28px;
    }
  }

  .section-subtitle {
    font-size: 18px;
    color: #666;
    max-width: 650px;
    margin: 0 auto;
    line-height: 1.7;
    font-weight: 300;

    @media (max-width: 575px) {
      font-size: 16px;
    }
  }

  .services-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;

    @media (max-width: 991px) {
      grid-template-columns: 1fr;
      gap: 25px;
    }
  }

  .service-card {
    background: #fff;
    border-radius: 16px;
    padding: 40px 35px;
    border: 1px solid #e8e8e8;
    transition: all 0.3s ease;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, #f16600, #ff8534);
      border-radius: 16px 16px 0 0;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    &:hover {
      border-color: rgba(241, 102, 0, 0.2);
      box-shadow: 0 15px 40px rgba(0, 0, 0, 0.08);
      transform: translateY(-4px);

      &::before {
        opacity: 1;
      }
    }

    @media (max-width: 575px) {
      padding: 30px 25px;
    }
  }

  .card-header {
    display: flex;
    align-items: center;
    gap: 18px;
    margin-bottom: 20px;
  }

  .icon-wrapper {
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, rgba(241, 102, 0, 0.08) 0%, rgba(241, 102, 0, 0.15) 100%);
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #f16600;
  }

  h3 {
    font-size: 22px;
    font-weight: 600;
    color: #1a1a2e;
    margin: 0;
    line-height: 1.3;

    @media (max-width: 575px) {
      font-size: 19px;
    }
  }

  .service-description {
    font-size: 16px;
    color: #555;
    line-height: 1.7;
    margin-bottom: 24px;
  }

  .service-details {
    margin-bottom: 20px;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 10px;
  }

  .detail-row {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 1.6;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .detail-label {
    font-weight: 700;
    color: #f16600;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.08em;
    min-width: 65px;
    padding-top: 2px;
  }

  .detail-text {
    color: #444;
    font-size: 14px;
  }

  .service-items {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    li {
      font-size: 13px;
      color: #666;
      padding: 6px 14px;
      background: #f0f0f0;
      border-radius: 20px;
      font-weight: 500;
    }
  }

  .services-cta {
    text-align: center;
    margin-top: 50px;

    button {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      background: linear-gradient(135deg, #f16600 0%, #ff8534 100%);
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      padding: 16px 35px;
      border-radius: 8px;
      border: none;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 8px 25px rgba(241, 102, 0, 0.3);

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 35px rgba(241, 102, 0, 0.4);
      }

      &:active {
        transform: translateY(-1px);
      }
    }
  }
`;

export default ConsultingServicesWrapper;
